import { Injectable } from '@angular/core';
import { LegacyConversion } from 'app/app-model/legacy-conversion.model';
import { SpecificationVersion } from 'app/app-model/specification-version';
import { ApiProxyService } from 'app/modules/shared/services/api-proxy.service';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ConfigService } from './config.service';

@Injectable({ providedIn: 'root' })
export class LegacyConversionService {

  constructor(private apiProxy: ApiProxyService, private configService: ConfigService) { }

  public upgradeSpecificationVersion(specificationVersion: SpecificationVersion): Observable<SpecificationVersion> {
    const legacyConversion = new LegacyConversion();
    legacyConversion.legacyVersionId = specificationVersion.id;
    legacyConversion.newSpecification = false;

    const upgradedVersionObservable = this.apiProxy.post<LegacyConversion>(`${this.configService.apiUrl}conversions/`, legacyConversion)
      .pipe(mergeMap(result => this.apiProxy.get<SpecificationVersion>(this.configService.apiUrl + 'versions/' + result.convertedVersionId)));

    return upgradedVersionObservable;
  }

  public syncOdxFileOnUpgradedSpecification(specificationVersion: SpecificationVersion): Observable<number>{
    return this.apiProxy.put<number>(`${this.configService.apiUrl}conversions/syncOdxFile/${specificationVersion.id}`, specificationVersion.id);
  }
}
